export function getBundleStatusColor(status) {
  const colors = {
    new: "blue",
    searching_driver: "orange",
    assigned: "purple",
    picking_up: "cyan",
    picked_up: "cyan",
    in_transit: "indigo",
    delivered: "green",
    cancelled: "red",
    returned: "grey",
    pending: "yellow darken-2",
    reserved: "purple",
  };
  return colors[status] || "grey";
}

export function getPackageStatusColor(status) {
  const colors = {
    new: "blue",
    reserved: "purple",
    under_collection: "orange",
    picked_up: "cyan",
    in_transit: "indigo",
    delivered: "green",
    returned: "red",
    pending: "yellow darken-2",
  };
  return colors[status] || "grey";
}

export function getServiceTypeLabel(type, t) {
  if (type === "direct") return t("PLACEHOLDERS.delivery_type_home");
  if (type === "distribution_point") return t("PLACEHOLDERS.delivery_type_point");
  return type || "-";
}

export function isPackageFinished(pkg) {
  return ["delivered", "returned"].includes(pkg.status);
}

export function formatDistance(km, t) {
  if (!km) return "-";
  return `${parseFloat(km).toFixed(2)} ${t("PLACEHOLDERS.km")}`;
}

export function formatDuration(mins, t) {
  if (!mins) return "-";
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  if (hours > 0) {
    return `${hours} ${t("PLACEHOLDERS.hours")} ${minutes} ${t("PLACEHOLDERS.minutes")}`;
  }
  return `${minutes} ${t("PLACEHOLDERS.minutes")}`;
}

export function formatPackageDims(dims, t) {
  if (!dims) return "-";
  const { length, width, height } = dims.dims || {};
  return `${dims.weight} ${t("PLACEHOLDERS.kg")} - ${length}x${width}x${height}`;
}

export function normalizeInvoiceData(invoice) {
  if (!invoice) return null;

  const bundle = invoice.bundle || {};
  const bundleProvider = bundle.provider || {};
  const bundleDriver = bundle.driver || {};

  return {
    ...invoice,
    qr_code: invoice.qr_code || invoice.qr || bundle.qr || null,
    package_number:
      invoice.package_number || bundle.bundle_number || invoice.id || "-",
    client_name: invoice.client_name || bundleProvider.name || "-",
    client_mobile: invoice.client_mobile || bundleProvider.mobile || "-",
    driver_name: invoice.driver_name || bundleDriver.name || "-",
    dp_name: invoice.dp_name || bundle.dp_name || null,
    delivery_fee:
      invoice.delivery_fee ??
      invoice.total_price ??
      bundle.delivery_fee ??
      0,
  };
}

export function getFilenameFromDisposition(disposition, fallbackName) {
  if (!disposition) return fallbackName;

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].replace(/['"]/g, ""));
  }

  const plainMatch = disposition.match(/filename=([^;]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].replace(/['"]/g, "").trim();
  }

  return fallbackName;
}
